import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from './loader.service';
import {finalize} from 'rxjs/internal/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private loader: LoaderService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const token = localStorage.getItem('token');

        if (token) {
            request = request.clone({
                setHeaders: {
                    Authorization: token
                }
            });
        }

        this.loader.incrementCount();
        return next.handle(request)
          .pipe(finalize(() => setTimeout(() => this.loader.decrementCount(), 0)));
    }
}
